module.exports = __webpack_public_path__ + "img/sone.1d4bbf1f.png";